import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useBadgesQuery = createQueryHook(MembershipsBadgesApiClient.getBadges, {
  queryKey: ['badges'],
})
